import { create } from 'zustand';
import apiClient from '../services/axiosInterceptor';

// Interface for CSV settings
interface CsvSettings {
  subjects_csv_url: string;
  classes_csv_url: string;
  fees_structure_csv_url: string;
}

// Interface for active school — now includes api_url
interface ActiveSchool {
    school_id: string | null;  // Changed from number to string

  school_name: string | null;
  api_url: string | null;
  configured: boolean;
}

// State interface for the store
interface DefaultDataState {
  active_school: ActiveSchool | null;
  csv_settings: CsvSettings | null;
  loading: boolean;
  error: string | null;

  fetchDefaultData: () => Promise<void>;
}

export const useDefaultDataStore = create<DefaultDataState>((set) => ({
  active_school: null,
  csv_settings: null,
  loading: false,
  error: null,

  fetchDefaultData: async () => {
    set({ loading: true, error: null });

    try {
      // Single request to get ALL meta values
      const response = await apiClient.get('/superuser-meta');
      
      console.log('All meta response:', response.data);

      // Extract ALL meta data from response
      const meta = response.data.meta || {};
      
      // Map ALL meta values to active school
      const mappedActiveSchool: ActiveSchool | null = {
          school_id: meta.active_school_id || null,  // ✅ Keep as string, no parseInt

        school_name: meta.active_school_name || null,
        api_url: meta.active_school_api_url || null,
        configured: !!meta.active_school_id,
      };

      // Map ALL CSV settings from meta
      const mappedCsvSettings: CsvSettings = {
        subjects_csv_url: meta['subjects.csv'] || '',
        classes_csv_url: meta['classes.csv'] || '',
        fees_structure_csv_url: meta['fees_structure.csv'] || '',
      };

      set({
        active_school: mappedActiveSchool,
        csv_settings: mappedCsvSettings,
        loading: false,
      });
    } catch (err: any) {
      const errorMessage =
        err.response?.data?.message ||
        err.message ||
        'Failed to load default data';

      set({
        loading: false,
        error: errorMessage,
      });
    }
  },
}));